<template>
  <div class="navbar-component">
    <div class="nav -nav">
      <nav class="navbar -navbar is-fixed-top">
        <div class="navbar-brand">
          <!-- close on click -->
          <a class="navbar-item" href="/" v-on:click="closeNavbar">
            <img src="@/assets/branding/text-logo-standard.png" />
          </a>
          <!-- toggle menu on click -->
          <a
            role="button"
            class="navbar-burger burger"
            v-bind:class="{ 'is-active': isActive }"
            aria-label="menu"
            aria-expanded="false"
            v-on:click="toggleNavbar"
          >
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </a>
        </div>
        <!-- bind class is-active to isActive -->
        <div class="navbar-menu -menu" v-bind:class="{ 'is-active': isActive }">
          <!-- toggle menu on click -->
          <div class="navbar-end" v-on:click="closeNavbar">
            <router-link
              v-for="page in pages"
              :key="page.title"
              class="navbar-item is-family-secondary"
              v-bind:class="{ '-active': page.isActivePage }"
              :to="page.route"
              >{{ page.title }}</router-link
            >
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "NavbarComponent",
  data() {
    return {
      isHoverable: true
    };
  },
  computed: {
    ...mapState({
      isActive: state => state.navbar.isActive,
      pages: state => state.pages.pages
    })
  },
  methods: {
    ...mapActions("navbar", ["openNavbar", "closeNavbar", "toggleNavbar"]),
    ...mapActions("pages", ["findActivePage"]),
    goTo(route) {
      this.$router.push(route);
      this.closeNavbar();
    },
    killHover() {
      this.isHoverable = false;
      setTimeout(() => {
        this.isHoverable = true;
      }, 100);
    },
    updated() {
      this.this.findActivePage(this.$route);
    }
  }
};
</script>

<style scoped lang="scss">
.-navbar {
  border-bottom: 1px solid #eeeeee;
  box-sizing: border-box;
}

.-menu {
  box-shadow: none;
}

.-active {
  color: hsl(217, 71%, 53%);
  background-color: #fafafa;
  box-sizing: border-box;
}
</style>
